import { InfoOutlined } from '@mui/icons-material';
import { Box, Popover, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { themeColors } from 'colors';
import Button from 'domains/core/components/Button';
import Chip from 'domains/core/components/Chip';
import { greyChipStyles } from 'domains/core/components/Chip/Chip';
import { ReservedKeywordsByCategory, reservedKeywordsByCategory } from './types';

const ReservedKeywords = () => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const renderReservedKeywordChips = (keywords: ReservedKeywordsByCategory['keywords']) =>
        keywords.map((keyword) => (
            <Chip
                key={keyword}
                label={keyword}
                sx={{
                    ...greyChipStyles,
                    color: 'text.primary',
                    marginRight: '8px',
                    marginTop: '4px',
                }}
            />
        ));

    const isPopoverOpen = Boolean(anchorEl);
    const popoverId = isPopoverOpen ? 'reserved-keywords-popover' : undefined;

    return (
        <Stack flexDirection="row">
            <InfoOutlined fontSize="inherit" sx={{ margin: '5px 8px 0 0' }} />
            <Box>
                <Typography variant="helperText" mr={0.5}>
                    Reserved keywords like STOP and START are auto-managed and can't be used for custom replies.
                </Typography>
                <Button
                    onClick={handleClick}
                    variant="text"
                    size="small"
                    sx={{
                        color: themeColors.secondary.main,
                        height: 'auto',
                        marginTop: '-2px',
                        padding: 0,
                        ':hover': { backgroundColor: 'transparent', textDecoration: 'underline' },
                    }}
                >
                    <Typography variant="helperText" color="inherit">
                        View full list of reserved keywords
                    </Typography>
                </Button>
                <Popover
                    id={popoverId}
                    open={isPopoverOpen}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Box maxWidth="220px" p={2}>
                        <Typography variant="body2">Reserved Keywords</Typography>
                        {reservedKeywordsByCategory.map((reservedKeyword) => (
                            <Box mt={1.5} key={reservedKeyword.category}>
                                <Typography variant="body2" sx={{ fontSize: '14px' }}>
                                    {reservedKeyword.category}
                                </Typography>
                                <Stack flexDirection="row" flexWrap="wrap">
                                    {renderReservedKeywordChips(reservedKeyword.keywords)}
                                </Stack>
                            </Box>
                        ))}
                    </Box>
                </Popover>
            </Box>
        </Stack>
    );
};

export default ReservedKeywords;
